export default "__VITE_ASSET__4ea2794e__"